import { AxiosError } from 'axios';
import { PaginationDataModel } from '../../../../shared/components/pagination/model/Pagination.model';
import { PaginationUtil } from '../../../../shared/components/pagination/utils/PaginationUtils';
import { left, right } from '../../../../shared/core/Either';
import { Result } from '../../../../shared/core/Result';
import { APIResponse } from '../../../../shared/infra/api/APIResponse';
import { BaseAPI } from '../../../../shared/infra/api/BaseAPI';
import { IAuthService } from '../../../users/services/authService';
import { CommunityAdminResponseDTO } from '../dtos/CommunityAdmin.dto';
import { CommunityAdminRequestDTO } from '../infra/types';
import { CommunityAdminModel } from '../models/CommunityAdmin.model';
import { CommunityAdminUtil } from '../utils/CommunityAdminUtil';

export interface ICommunityAdminService {
  getCommunityAdministrators(
    offset?: number,
    filter?: string,
    dir?: number,
    search?: string,
  ): Promise<APIResponse<PaginationDataModel<CommunityAdminModel[]>>>;
  createCommunityAdmin(
    communityAdmin: CommunityAdminRequestDTO,
  ): Promise<APIResponse<void>>;
}

export class CommunityAdminService
  extends BaseAPI
  implements ICommunityAdminService {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected onFailureExecuteImpl(error: AxiosError<any>): Promise<any> {
    throw new Error('Method not implemented.');
  }
  constructor(authService: IAuthService) {
    super(authService);
  }

  hasToken(): boolean {
    return this.authService.isUserAuthenticated();
  }

  public async getCommunityAdministrators(
    offset?: number,
    filter?: string,
    dir?: number,
    search?: string,
  ): Promise<APIResponse<PaginationDataModel<CommunityAdminModel[]>>> {
    try {
      const response = await this.get<CommunityAdminResponseDTO>({
        url: '/v1/administrator/communities/admin',
        requiresToken: true,
        config: {
          params: {
            offset,
            filter,
            dir,
            search,
          },
        },
      });

      const { data, meta } = response.data;

      return right(
        Result.ok<PaginationDataModel<CommunityAdminModel[]>>({
          model: data.map((admin) => CommunityAdminUtil.mapToViewModel(admin)),
          meta: PaginationUtil.mapToViewModel(meta),
        }),
      );
    } catch (err: any) {
      return left(err.response ? err.response.data : 'Connection failed');
    }
  }

  public async createCommunityAdmin(
    communityAdmin: CommunityAdminRequestDTO,
  ): Promise<APIResponse<void>> {
    try {
      await this.post<CommunityAdminRequestDTO>({
        url: '/v1/users/administrator/community',
        requiresToken: true,
        payload: communityAdmin,
      });

      return right(Result.ok<void>());
    } catch (err: any) {
      return left(err.response ? err.response.data : 'Connection failed');
    }
  }
}
